const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getHistoricalAnnouncementsReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'HISTORICAL_ANNOUNCEMENTS_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'HISTORICAL_ANNOUNCEMENTS_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'HISTORICAL_ANNOUNCEMENTS_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'HISTORICAL_ANNOUNCEMENTS_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getHistoricalAnnouncementsReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getHistoricalAnnouncementsReport.js